/* src/app/front-layout/python-course/python-course.component.css */
.py-hero-sec {
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 40px;
  background-color: white;
  font-family: "Arial", sans-serif;
  background-image: url(/assets/images/pyhs-bg.png);
  background-attachment: fixed;
  background-repeat: no-repeat;
  background-size: cover;
  place-items: center;
}
.hs-cnt {
  width: 100%;
  display: flex;
  align-items: center;
}
.hs-cnt-right {
  width: 60%;
  display: flex;
  flex-direction: column;
}
.hs-cnt-right div {
  display: flex;
  width: 200px;
  padding: 10px;
  background-color: #46CDF3;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  border-radius: 35px;
  font-weight: 600;
}
.hs-head {
  font-size: 40px;
  font-weight: 700;
  margin-top: 20px;
}
.hs-cnt-right h3 {
  color: #007BA7;
}
.hs-cnt-right p {
  font-size: 16px;
}
.cta-1 {
  padding: 15px;
  width: 250px;
  background-color: #007BA7;
  border: none;
  border-radius: 35px;
  font-size: 18px;
  font-weight: 700;
  color: white;
  margin-top: 20px;
  margin-bottom: 20px;
}
.hs-cnt-left {
  width: 50%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.hs-cnt-left img {
  width: 600px;
}
.ch-container {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.sec-head {
  font-size: 40px;
  font-weight: 700;
  margin-bottom: 20px;
}
.ch-cards-container {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  flex-wrap: wrap;
}
.ch-card {
  width: 300px;
  border-radius: 20px;
  padding: 10px;
  margin: 20px;
  background-color: #F7F7F7;
}
.ch-card img {
  width: 100%;
  height: 200px;
  border-radius: 20px;
  object-fit: cover;
}
.ch-card h4 {
  font-size: 18px;
  font-weight: 700;
  margin-bottom: 10px;
  color: black;
}
.cd-sec {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.sessions-overview-row {
  max-width: 1200px;
  margin: 42px auto 0 auto;
  background: #fff;
  box-shadow: 0 2px 16px rgba(92, 92, 92, 0.08);
  border-radius: 10px;
  display: flex;
  align-items: stretch;
  min-height: 300px;
}
.session-features {
  flex: 3 1 0;
  padding: 36px 36px 36px 48px;
  display: flex;
  align-items: center;
}
.session-features ul {
  list-style: disc inside;
  font-size: 2rem;
  color: #222;
  padding-left: 0;
  margin: 0;
}
.session-features li {
  margin-bottom: 16px;
}
.session-side-box {
  background: #007BA7;
  color: #fff;
  min-width: 500px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 4rem;
  font-weight: 600;
  border-radius: 0 10px 10px 0;
  clip-path: polygon(20% 0, 100% 0, 100% 100%, 0 100%);
  padding: 0 34px;
  text-align: center;
}
.session-side-box span {
  display: block;
}
.section-breakdown {
  max-width: 80%;
  margin: 0 auto 56px auto;
  padding: 0 12px;
}
.section-breakdown h2 {
  text-align: center;
  font-size: 4rem;
  margin: 36px 0 28px 0;
  font-weight: 600;
  color: #151515;
}
.accordion {
  width: 100%;
}
.accordion-item {
  background: #fafafa;
  border: 1px solid #ececec;
  border-radius: 2px;
  margin-bottom: 18px;
  overflow: hidden;
  transition: box-shadow 0.22s;
}
.accordion-item.open {
  background: #f5f5f5;
  box-shadow: 0 3px 18px rgba(70, 70, 70, 0.04);
}
.accordion-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  padding: 18px 24px 18px 16px;
  background: rgba(0, 0, 0, 0.04);
  font-size: 2rem;
  font-weight: 600;
  border-bottom: 1px solid #ededed;
  -webkit-user-select: none;
  user-select: none;
  transition: background 0.18s;
}
.accordion-item:not(.open) .accordion-header {
  border-bottom: none;
}
.accordion-header:hover {
  background: #efeae7;
}
.accordion-icon {
  transition: transform 0.33s cubic-bezier(.45, 1.59, .42, .98);
}
.accordion-item.open .accordion-icon {
  transform: rotate(180deg);
}
.accordion-content {
  max-height: 0;
  opacity: 0;
  overflow: hidden;
  padding: 0 24px;
  background: #fff;
  font-size: 1.5rem;
  color: #181818;
  transition: all 0.36s cubic-bezier(.55, 1.76, .51, 1);
}
.accordion-item.open .accordion-content {
  max-height: 900px;
  opacity: 1;
  padding: 18px 24px 20px 24px;
  border-top: none;
}
.accordion-content ul {
  margin: 0 0 10px 0;
  padding-left: 20px;
}
.accordion-content li {
  margin-bottom: 7px;
}
@media screen and (max-width: 768px) {
  .py-hero-sec {
    height: auto;
    padding: 30px 20px;
    background-attachment: scroll;
  }
  .hs-cnt {
    margin-top: 100px;
    flex-direction: column;
    text-align: center;
  }
  .hs-cnt-right {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    margin-bottom: 30px;
  }
  .hs-cnt-left {
    width: 100%;
  }
  .hs-cnt-left img {
    width: 100%;
    max-width: 400px;
  }
  .hs-head {
    font-size: 32px;
  }
  .ch-cards-container {
    grid-template-columns: repeat(2, 1fr);
  }
  .ch-card {
    width: 100%;
    margin: 10px;
  }
  .sessions-overview-row {
    flex-direction: column;
    min-height: auto;
  }
  .session-features {
    padding: 20px;
    width: 100%;
  }
  .session-features ul {
    font-size: 1.6rem;
  }
  .session-side-box {
    min-width: 100%;
    clip-path: none;
    border-radius: 0 0 10px 10px;
    padding: 20px;
    font-size: 2.5rem;
  }
  .section-breakdown {
    max-width: 95%;
  }
  .section-breakdown h2 {
    font-size: 3rem;
  }
  .accordion-header {
    font-size: 1.6rem;
    padding: 14px 18px;
  }
  .accordion-content {
    font-size: 1.3rem;
  }
}
@media screen and (max-width: 480px) {
  .py-hero-sec {
    padding: 20px 15px;
  }
  .hs-head {
    font-size: 28px;
    margin-top: 15px;
  }
  .hs-cnt-right h3 {
    font-size: 20px;
  }
  .hs-cnt-right p {
    font-size: 15px;
  }
  .cta-1 {
    width: 200px;
    padding: 12px;
    font-size: 16px;
  }
  .hs-cnt-left img {
    max-width: 300px;
  }
  .sec-head {
    font-size: 28px;
  }
  .ch-cards-container {
    grid-template-columns: 1fr;
  }
  .ch-card {
    margin: 10px 0;
  }
  .ch-card img {
    height: 160px;
  }
  .ch-card h4 {
    font-size: 16px;
  }
  .session-features ul {
    font-size: 1.4rem;
  }
  .session-features li {
    margin-bottom: 12px;
  }
  .session-side-box {
    font-size: 2rem;
    padding: 15px;
  }
  .section-breakdown h2 {
    font-size: 2.2rem;
    margin: 25px 0 20px 0;
  }
  .accordion-header {
    font-size: 1.4rem;
    padding: 12px 15px;
  }
  .accordion-content {
    font-size: 1.2rem;
    padding: 15px;
  }
  .accordion-item.open .accordion-content {
    padding: 15px;
  }
}
/*# sourceMappingURL=python-course.component.css.map */
